import Avatar from '@mui/material/Avatar'
import './UserAvatar.css'
import { UserAvatarPopoverItems } from './UserAvatarPopoverItems.tsx'
import { UsersService } from '@/user/UsersService'
import { useOptionsPopover } from '../popover/popover-hooks.tsx'
import { DefaultPopover } from '../popover/DefaultPopover.tsx'
import type { CssThemeService } from '../app-shell/CssThemeService'
import { useDiRef } from '@/common/react/di-hooks'
import { useBehaviorObservable } from '@/common/react/observable-hooks'
import { useTutorialTarget } from '@/tutorial/TutorialContext'
import { globalCssVars } from 'core/theme/GlobalCssVars.ts'

export function UserAvatar() {
  const { anchorEl, openPopover, closePopover } = useOptionsPopover()

  const cssThemeService = useDiRef<CssThemeService>('CssThemeService')
  const usersService = useDiRef<UsersService>('UsersService')
  const userData = useBehaviorObservable(usersService.user$)

  function getInitials(name: string) {
    const words = name.replace(/-/g, ' ').split(' ').filter(Boolean)
    return words.map((w) => w[0].toUpperCase()).join('')
  }

  const tutorialTargetRef = useTutorialTarget('user-avatar')
  const size = globalCssVars.headerHeight * 0.75
  const initials = userData ? getInitials(userData.name) : ''
  return (
    <>
      <Avatar
        ref={tutorialTargetRef}
        className="userAvatar"
        onClick={(e) => {
          openPopover(e.currentTarget)
        }}
        sx={{
          width: size,
          height: size,
          fontSize: 13,
        }}
      >
        {initials}
      </Avatar>

      <DefaultPopover
        anchorEl={anchorEl}
        close={closePopover}
        slotSx={{ paper: { alignItems: 'stretch' } }}
      >
        <UserAvatarPopoverItems />
      </DefaultPopover>
    </>
  )
}
